import { serverUrl } from "./config";

const API_BASE_URL = serverUrl + "admin";

// Helper function to get auth token from localStorage (backup method)
const getAuthToken = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('authToken');
  }
  return null;
};

export const api = {
  get: async (endpoint) => {
    // Get token from localStorage as fallback
    const token = getAuthToken();
    const headers = {
      'Content-Type': 'application/json',
    };

    // Add Authorization header if token exists in localStorage
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        credentials: "include", // For cookies
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Handle unauthorized access
          // Force a hard redirect to ensure cookies and state are cleared
          window.location.href = "/signin";
          throw new Error("Unauthorized");
        }
        const error = await response.json();
        throw new Error(error.message || "Something went wrong");
      }
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  post: async (endpoint, data, options = {}) => {
    // Get token from localStorage as fallback
    const token = getAuthToken();
    const headers = options.headers || {
      'Content-Type': 'application/json',
    };
    // Add Authorization header if token exists in localStorage
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: "POST",
        credentials: "include", // For cookies
        headers,
        body: data instanceof FormData ? data : JSON.stringify(data),
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Handle unauthorized access
          // Force a hard redirect to ensure cookies and state are cleared
          window.location.href = "/signin";
          throw new Error("Unauthorized");
        }
        const error = await response.json();
        throw new Error(error.message || "Something went wrong");
      }
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  put: async (endpoint, data, options = {}) => {
    // Get token from localStorage as fallback
    const token = getAuthToken();
    const headers = options.headers || {
      'Content-Type': 'application/json',
    };

    // Add Authorization header if token exists in localStorage
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: "PUT",
        credentials: "include", // For cookies
        headers,
        body: data instanceof FormData ? data : JSON.stringify(data),
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Handle unauthorized access
          // Force a hard redirect to ensure cookies and state are cleared
          window.location.href = "/signin";
          throw new Error("Unauthorized");
        }
        const error = await response.json();
        throw new Error(error.message || "Something went wrong");
      }
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  delete: async (endpoint) => {
    // Get token from localStorage as fallback
    const token = getAuthToken();
    const headers = {
      'Content-Type': 'application/json',
    };

    // Add Authorization header if token exists in localStorage
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: "DELETE",
        credentials: "include", // For cookies
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Handle unauthorized access
          // Force a hard redirect to ensure cookies and state are cleared
          window.location.href = "/signin";
          throw new Error("Unauthorized");
        }
        const error = await response.json();
        throw new Error(error.message || "Something went wrong");
      }
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },
}; 